export default "__VITE_ASSET__f2130461__"